import {
  ClinicalImpressionAssessmentValueCode,
  ClinicalImpressionCode,
  ClinicalImpressionLocationCode,
  ClinicalImpressionPlanValueCode,
  createReferenceValidationSchema,
  type ObjectType,
} from '@quromedical/fhir-common';
import * as yup from 'yup';
import { createMediaDataSchema } from '../media/validation';

import type {
  CreateNote,
  CreateSOAPNote,
  NoteUpdate,
  StructuredContent,
  StructuredContentType,
} from './schema';

const clinicalImpressionCodes = Object.values(ClinicalImpressionCode);
const codeSchema = yup.string().required().oneOf(clinicalImpressionCodes);

const locationCodes = Object.values(ClinicalImpressionLocationCode);
const locationCodeSchema = yup.string().required().oneOf(locationCodes);

const assessmentCodes = Object.values(ClinicalImpressionAssessmentValueCode);
const assessmentCodeSchema = yup.string().required().oneOf(assessmentCodes);

const planCodes = Object.values(ClinicalImpressionPlanValueCode);
const planCodeSchema = yup.string().required().oneOf(planCodes);

const mediaListSchema = yup.array(createMediaDataSchema).required().max(5);

const noteSchema = yup.object<ObjectType<CreateSOAPNote>>({
  subjective: yup.string().required(),
  assessmentCode: assessmentCodeSchema,
  planCode: planCodeSchema,

  assessment: yup.string().notRequired(),
  plan: yup.string().notRequired(),
  objective: yup.string().notRequired(),
});

const structuredContentTypes: StructuredContentType[] = [
  'nested-comment-nodes',
];

export const createNoteSchema = yup.object<ObjectType<CreateNote>>({
  subject: yup.string().required(),
  code: codeSchema,
  locationCode: locationCodeSchema,
  media: mediaListSchema,
  note: noteSchema,
  vitals: yup.object().required(),
  // this should be updated to just be strings once the practitioner list is made just ids
  practitionersToNotify: yup
    .array(createReferenceValidationSchema('Practitioner'))
    .required(),
  structuredContent: yup
    .object<ObjectType<StructuredContent>>({
      type: yup.string().required().equals([structuredContentTypes]),
      data: yup.mixed().required(),
    })
    .optional()
    .default(undefined),
});

export const noteUpdateSchema = yup.object<ObjectType<NoteUpdate>>({
  subjective: yup.string().required(),
});
